package com.ervasstudio.tracoemovimento.model

enum class PopupState {
    FORM,      // Tela com os inputs
    LOADING,   // Tela com indicador de carregamento
    SUCCESS    // Tela de sucesso (dura 3 segundos)
}